import type { GetAccountEntriesResponse } from '../types'
import type { ModalPortalPayloadMap } from '@app/types'

import SFetch from '@app/utils/sfetch'

export const getAccountEntries = ({
  companyId = window.Silverfin.jsonParams.company_id as string,
  ledgerId,
  ranges,
  includeZerosValue,
  addRoundingDifference,
  unit,
  precision,
  analyticalDimensionId,
  starred,
}: ModalPortalPayloadMap['account-entries-modal']): Promise<GetAccountEntriesResponse | null | void> => {
  const params = {
    ...window.Silverfin.jsonParams,
    company_id: companyId,
    ledger_id: ledgerId,
  }
  const body = {
    include_zeros_value: includeZerosValue,
    analytical_dimension_id: analyticalDimensionId,
    ranges,
    add_rounding_difference: addRoundingDifference,
    unit,
    precision,
    starred,
    _options: true,
  }

  const url =
    window.Silverfin.Routes.for_ranges_ledger_account_entries_path(params)

  return SFetch.jsonWithAlert<GetAccountEntriesResponse>(url, {
    method: 'post',
    body,
  })
}
